<template>
    <div id="smartLabel">
        <!--banner区域-->
        <div class="bannerWrap">
            <div class="contentWrap">
                <div class="content">
                    <div class="contentTitle">智能标签</div>
                    <div class="contentVal">
                        <span>通过大数据技术加密聚类得到标签</span>
                        <span>标签+推荐算法服务推广、营销、洞察等业务</span>
                    </div>
                    <button class="btn" @click="showAlertFlag=true">立即咨询</button>
                </div>
            </div>
        </div>
        <!--内容区-->
        <div class="smartLabelConWrap">
            <!--例子-->
            <div class="exampleBox">
                <div class="left">
                    <div class="leftList" v-for="(item,index) in leftData" :key="index">
                        <div class="name">
                            {{item.name}} <span>{{item.work}}</span>
                        </div>
                        <div class="wordWrap" v-html="item.val"></div>
                    </div>
                </div>
                <div class="right">
                    <div class="rightTitle">每个用户都有标签，每个企业该应用</div>
                    <div class="rightList" v-for="(item,index) in rightData" :key="index"
                         @click="chooseExampleEvent(index)">
                        <span></span>
                        <p v-html="item.val"></p>
                    </div>
                </div>
            </div>
            <!--产品设计-->
            <div class="productWrap">
                <div class="headline">产品设计</div>
                <div class="productBox">
                    <div class="listBox" :class="proIndex===1 ? 'active' : '' " @mouseover="proEvent(1)">
                        <div class="proTitle">
                            <img src="../../assets/01.png" v-show="proIndex!==1"/>
                            <img src="../../assets/01焦点.png" v-show="proIndex===1"/>
                            <span>定义核心人群，针对客户<br/>需求设计受众策略</span>
                        </div>
                        <div class="proEnTitle">DEFINE CORE POPULATION, DESIGN AUDIENCE STRATEGY</div>
                        <div class="proVal" v-show="proIndex===1">
                            数据分析师针对各行业产品的受众特性进行多维度的动态分析并输出分析框架，结合各行业特性和优质种子样本的消费喜好和心理偏好设计受众策略
                        </div>
                    </div>
                    <div class="listBox" :class="proIndex===2 ? 'active' : '' " @mouseover="proEvent(2)">
                        <div class="proTitle">
                            <img src="../../assets/02.png" v-show="proIndex!==2"/>
                            <img src="../../assets/02焦点.png" v-show="proIndex===2"/>
                            <span>智能生产符合<br/>目标需求的标签</span>
                        </div>
                        <div class="proEnTitle">INTELLIGENT PRODUCTION OF LABELS THAT MEET TARGET NEEDS</div>
                        <div class="proVal" v-show="proIndex===2">
                            依托神经网络计算系统的机器学习能力，汇集海量参数，进行智能算法加工，精心打造全品类标签矩阵，针对客户选择的维度，智能地推荐专属标签，解决各行业竞争大、扩量难、投不准等营销痛点，并辅助各类型企业实现精细化运营的目标
                        </div>
                    </div>
                    <div class="listBox" :class="proIndex===3 ? 'active' : '' " @mouseover="proEvent(3)">
                        <div class="proTitle">
                            <img src="../../assets/03.png" v-show="proIndex!==3"/>
                            <img src="../../assets/03焦点.png" v-show="proIndex===3"/>
                            <span>动态优化<br/>受众策略与标签参数</span>
                        </div>
                        <div class="proEnTitle">DYNAMICALLY OPTIMIZE AUDIENCE STRATEGY AND TAG DATA</div>
                        <div class="proVal" v-show="proIndex===3">
                            基于标签的作用参数效果为准，根据不同的场景效果反馈作出调整，优化受众策略并驱动标签客群参数达到最优的作用效果后形成服务闭环
                        </div>
                    </div>
                </div>
            </div>
            <!--应用价值-->
            <div class="applicationValue">
                <div class="headline">应用价值</div>
                <div class="applicationValueBox">
                    <div class="applicationValueList">
                        <img src="../../assets/img/smartLabel/广告.png"/>
                        <div class="listTitle">广告投放</div>
                        <div class="listVal">
                            通过智能技术建立特征标签，根据特征标签人群进行精准的智能投放，提高投放精准度与转化率
                        </div>
                    </div>
                    <div class="applicationValueList">
                        <img src="../../assets/img/smartLabel/金融.png"/>
                        <div class="listTitle">金融行业</div>
                        <div class="listVal">
                            依托神经网络计算技术的机器学习能力，搭建以用户为中心的大数据运营体系，通过对用户参数的梳理，理解、识别、提取用户特征并输出标签，了解潜在用户，识别低风险、高价值客户，辅助企业更加有针对性地设计金融产品，更有效地解决问题
                        </div>
                    </div>
                    <div class="applicationValueList">
                        <img src="../../assets/img/smartLabel/电商.png"/>
                        <div class="listTitle">电商营销</div>
                        <div class="listVal">
                            整合并优化参数后输出标签，赋能营销服务，助力电商企业解决营销痛点，获取销售线索快速实现精准营销，推送营销方案高效触达用户端，精准匹配用户需求，提升目标人群触达率
                        </div>
                    </div>
                    <div class="applicationValueList">
                        <img src="../../assets/img/smartLabel/零售.png"/>
                        <div class="listTitle">传统零售</div>
                        <div class="listVal">
                            挖掘传统零售的商业参数，发现其商业价值。整合零售行业用户参数、供应链参数、品牌参数，对参数进行评级输出标签，结合业务需求利用标签进行策略优化，提高用户购买率，降低用户流失率，由内而外地解决零售痛点
                        </div>
                    </div>
                </div>
            </div>
            <!--案例-->
            <div class="caseWrap">
                <div class="headline">案例</div>
                <div class="caseBox">
                    <div class="caseList">
                        <img src="../../assets/img/exampleImg/某企业筛选用户以提升交易额.png" class="leftImg"/>
                        <div class="rightVal">
                            <div class="rightValTitle">某企业筛选用户以提升交易额</div>
                            <div class="rightValText">
                                某企业为提升理财的交易额，把从流失的用户获取理财交易额的增长作为其中一个策略，并定义为对于交易流失用户的潜客营销。投放人群策略描述为交易高价值客户，且处于交易流失期的有理财意向的非理财用户，从各种各样维度选取相应标签，并通过标签快捷筛选获取名单，然后实施精准触达用户
                            </div>
                        </div>
                    </div>
                    <div class="caseList">
                        <img src="../../assets/img/exampleImg/某CRM团队的流失用户预测模型.png" class="leftImg"/>
                        <div class="rightVal">
                            <div class="rightValTitle">某CRM团队的流失用户预测模型</div>
                            <div class="rightValText">
                                某公司的CRM团队，希望知道用户流失的概率，根据流失概率定期对相关的用户进行营销，降低用户的流失率。所以决定从而打上流失概率标签构建模型，通过理解业务沟通分析流失用户特征，相应去找到或者设计预期指标，然后设计流失用户的预测模型
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--相关产品-->
            <div class="relevantProduct">
                <div class="headline">相关产品</div>
                <!--产品列表-->
                <div class="relevantProductListWrap">
                    <div class="relevantProductList" @click="toPage('/factorServices')" style="margin-right: 114px;">
                        <img src="../../assets/img/bigIcon/因子服务.png"/>
                        <span>因子服务</span>
                    </div>
                    <div class="relevantProductList" @click="toPage('/modelFactory')" style="margin-right: 98px;">
                        <img src="../../assets/img/bigIcon/模型工厂.png"/>
                        <span>模型工厂</span>
                    </div>
                    <div class="relevantProductList" @click="toPage('/znkqdcSystem')">
                        <img src="../../assets/img/bigIcon/智能客群洞察系统.png"/>
                        <span>客群洞察系统</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="alertBox" v-show="showAlertFlag">
            <div class="alertBoxHeader">
                <span>服务咨询</span>
                <img src="../../assets/关闭.png" height="11" width="11" @click="showAlertFlag=false"/>
            </div>
            <div class="alertBoxVal">
                <div>为您提供售前购买咨询、产品推荐等</div>
                <p>电话：<span>0755-86969845</span>（工作日 9:30-18:30）</p>
                <p>微信：ylw2539</p>
                <p>邮箱：yu@houselai.com</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "smartLabel",
        data() {
            return {
                proIndex: 1,
                /*数据*/
                rightData: [
                    {val: "智能标签对营销的作用是无可比拟的"},
                    {val: "关注我的产品的是怎么样的用户群体？"},
                ],
                allData: {
                    0: [
                        {
                            name: "张先生", work: "某公司销售",
                            val: "营销的目的就是希望能让通过一些运营与销售方式让产品或服务销售成功，有" +
                                "几种方式，一是基于物品推荐，二是基于用户推荐，三是通过一些特征联系用户" +
                                "和物品，给用户推荐那些具有用户喜欢的特征的物品<br/>" +
                                "通过大数据打标签结合推荐算法就能很好地服务营销，基于智能标签服务的智能" +
                                "推荐提升营销效果是目前常用的方式"
                        },
                        {
                            name: "徐小姐", work: "某互联网企业营销人员",
                            val: "如何在ZB级的海量数据中获取并筛选有价值的信息，是对IT企业的一大挑战。" +
                                "通过构建客户标签，支撑精准营销服务，是应对上述挑战的有效解决方案。用户" +
                                "标签是精细化运营的基础，能有效提高流量的分发效率和转化效率<br/>" +
                                "利用大数据搭建完善的用户标签体系，需要尽可能汇总最大范围内的数据。同时" +
                                "每个产品线也要集合所有端的数据才能更有效地筛选价值信息"
                        },
                        {
                            name: "闻先生", work: "某创业公司合伙人",
                            val: "亚马逊的CEO Jeff Bezos曾说过“如果我有一百万的用户，我就会做一百万个不" +
                                "同的网站“，做这个基础是先对用户打标签。目前众多企业基于标签的智能推荐系统" +
                                "拓展自身的业务<br/>" +
                                "通过大数据技术实现营销学习的智能化和个性化，构建这样一平台，建立基于用户" +
                                "的标签体系打造营销的智能推荐系统，解决营销效率低下、不精准等众多问题"
                        }
                    ],
                    1: [
                        {
                            name: "吴先生", work: "某地产从业人员",
                            val: "面对持续不断的多城严峻调控，开发商们却依旧拿地热情不减。中国房地产市" +
                                "场瞬息万变，已经开始了新的篇章。房产投资拿地如何选择，成为了当下开发商们" +
                                "首先考虑的要事<br/>" +
                                "通过大数据技术打标签，基于标签了解一个区域的客户群体的购买力以及产品偏好" +
                                "，从而推定当地居民的购房倾向性"
                        },
                        {
                            name: "谢女士", work: "某教育公司销售总监",
                            val: "某企业会员管理系统实际用户的互动率、留存率很低，更不要提复购以及延展购" +
                                "买，所以其提出以下核心需求：通过会员管理系统促进用户的互动、提高用户留存" +
                                "；在会员管理系统中针对不同的用户推荐个性化的内容；达到精准营销<br/>" +
                                "这就需要依托大数据挖掘实际用户的需求是怎么样的，也就是打标签分析，然后相应" +
                                "定制解决方案提升营销终端能力"
                        },
                        {
                            name: "贾先生", work: "某车企运营人员",
                            val: "随着信息化时代的到来，用户获取信息的渠道和门槛越来越广泛，也越来越低。" +
                                "购车用户会更加综合的去考虑各项指标，用户在购车前对各项汽车相关因素的关注" +
                                "度均有提升，而且提升幅度尤为明显，这些指标就是关心的标签数据<br/>" +
                                "经过大数据处理出来的标签结果，以客户为中心、进行价值创造并有效传递至客户" +
                                "才是营销的真谛所在"
                        }
                    ],
                },
                leftData: [],
                showAlertFlag: false
            }
        },
        created() {
            /*初始化案例*/
            this.leftData = this.allData[0];
        },
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            toPage(page) {
                this.$router.push({path: page});
            },
            proEvent(index) {
                this.proIndex = index;
            },
            scrollFun() {
                this.$animate(document.getElementsByClassName("content")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("exampleBox")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("productWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("applicationValue")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("caseWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("relevantProduct")[0], "fadeInUp");
            },
            /*切换案例数据*/
            chooseExampleEvent(index) {
                this.leftData = this.allData[index];
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    #smartLabel {
        .bannerWrap {
            background: url("../../assets/img/smartLabel/智能标签banner.png") no-repeat center;
            background-color: #00051D;
        }

        .smartLabelConWrap {
            background: url("../../assets/bgImg.png");
            background-size: cover;
            background-position: center;
            padding-top: 80px;

            .exampleBox {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                width: 1200px;
                margin: 0 auto 120px;
                padding: 0 0 0 76px;

                .left {
                    width: 458px;
                    margin-right: 128px;

                    .leftList {
                        padding: 20px 20px 20px 31px;
                        margin-bottom: 16px;
                        border-radius: 4px;
                        border: 1px solid #EAEEF4;
                        background: #fff;

                        &:last-child {
                            margin-bottom: 0;
                        }

                        .name {
                            margin-bottom: 4px;
                            font-size: 14px;
                            color: #1B2D35;

                            span {
                                margin-left: 10px;
                                font-size: 12px;
                                color: #40B0FF;
                            }
                        }

                        .wordWrap {
                            opacity: 0.6;
                            margin-bottom: 4px;
                            font-size: 12px;
                            color: #152346;
                            text-align: justify;
                            line-height: 24px;

                            &:last-child {
                                margin-bottom: 0;
                            }
                        }
                    }
                }

                .right {
                    .rightTitle {
                        margin-bottom: 60px;
                        font-size: 30px;
                        color: #152346;
                    }

                    .rightList {
                        display: flex;
                        align-items: center;
                        margin-bottom: 40px;
                        line-height: 22px;
                        cursor: pointer;

                        &:last-child {
                            margin-bottom: 0;
                        }

                        span {
                            display: inline-block;
                            width: 12px;
                            height: 12px;
                            border-radius: 50%;
                            margin-right: 22px;
                            background: #22A5FF;
                        }

                        p {
                            font-size: 16px;
                            color: #152346;
                        }
                    }
                }
            }

            .productWrap {
                .productBox {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 1200px;
                    height: 330px;
                    margin: 70px auto 112px;

                    .listBox {
                        height: 100%;
                        padding: 69px 0 0 40px;
                        cursor: pointer;
                        background: #F6F9FF;
                        flex: 1;
                        transition: all .4s;

                        .proTitle {
                            position: relative;
                            margin-bottom: 32px;
                            font-size: 26px;
                            color: #152346;
                            line-height: 40px;
                            font-weight: bold;

                            span {
                                display: inline-block;
                                position: relative;
                                z-index: 100;
                            }

                            img {
                                position: absolute;
                                left: 0;
                                bottom: 20px;
                            }
                        }

                        .proEnTitle {
                            opacity: 0.3;
                            font-size: 12px;
                            color: #152346;
                            letter-spacing: 0.17px;
                            line-height: 22px;
                        }
                    }

                    .active {
                        min-width: 540px;
                        background: url("../../assets/produceBlueBg.png") no-repeat center;
                        background-size: cover;

                        .proTitle {
                            margin-bottom: 0 !important;
                            font-size: 32px !important;
                            color: #FFFFFF;
                            line-height: 40px !important;
                        }

                        .proEnTitle {
                            margin-bottom: 20px;
                            font-size: 14px !important;
                            color: #FFFFFF !important;
                            letter-spacing: 0.4px !important;
                            line-height: 24px !important;
                        }

                        .proVal {
                            padding-right: 40px;
                            font-size: 12px;
                            color: #FDFDFD;
                            line-height: 22px;
                        }
                    }
                }
            }

            .applicationValue {
                .applicationValueBox {
                    display: flex;
                    justify-content: space-between;
                    width: 1200px;
                    margin: 0 auto 130px;

                    .applicationValueList {
                        width: 200px;
                        text-align: center;

                        img {
                            width: 50px;
                            height: 50px;
                            margin-bottom: 24px;
                        }

                        .listTitle {
                            margin-bottom: 12px;
                            font-size: 20px;
                            color: #152346;
                        }

                        .listVal {
                            opacity: 0.7;
                            font-size: 12px;
                            color: #152346;
                            line-height: 22px;
                            text-align: justify;
                        }
                    }
                }
            }

            .caseWrap {
                .caseBox {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 1200px;
                    margin: 0 auto;

                    .caseList {
                        display: flex;
                        align-items: flex-start;

                        .leftImg {
                            width: 192px;
                            height: 186px;
                            margin-right: 16px;
                        }

                        .rightVal {
                            padding-top: 16px;

                            .rightValTitle {
                                opacity: 0.6;
                                margin-bottom: 10px;
                                font-size: 20px;
                                color: #152346;
                            }

                            .rightValText {
                                width: 339px;
                                opacity: 0.4;
                                font-size: 12px;
                                color: #152346;
                                line-height: 24px;
                            }
                        }
                    }
                }
            }

            .relevantProduct {
                width: 436px;
            }
        }
    }
</style>
